import {
  clearIndicatorStyles,
  controlStyles,
  dropdownIndicatorStyles,
  groupHeadingStyles,
  indeterminateClearIndicatorStyles,
  indeterminateDropdownIndicatorStyles,
  indeterminateIndicatorSeparatorStyles,
  indeterminateMultiValueLabelStyles,
  indeterminateMultiValueStyles,
  indeterminatePlaceholderStyles,
  indicatorSeparatorStyles,
  menuList,
  menuStyles,
  multiValueLabelStyles,
  multiValueRemoveStyles,
  multiValueStyles,
  noOptionsMessageStyles,
  optionStyles,
  placeholderStyles,
  selectInputStyles,
  singleValueStyles,
  valueContainerStyles,
} from '@/components/ui/react-select-styles';
import { cn } from '@/lib/utils';

// react-select passes every prop given to <Select> to the classNames slot
// functions via `selectProps`. Consumers forward these custom props so the
// shared config can react to them without a per-consumer classNames object.
interface SelectStateProps {
  'indeterminate'?: boolean;
  'aria-invalid'?: boolean | 'true' | 'false';
  'menuListStyle'?: string;
}

const isAriaInvalid = (value: SelectStateProps['aria-invalid']) => value === true || value === 'true';

export const shareDialogSelectClassNames = {
  control: ({
    isFocused,
    isDisabled,
    selectProps,
  }: {
    isFocused: boolean;
    isDisabled: boolean;
    selectProps: SelectStateProps;
  }) =>
    cn(
      isDisabled && controlStyles.disabled,
      isFocused ? controlStyles.focus : controlStyles.nonFocus,
      controlStyles.base,
      selectProps.indeterminate && controlStyles.indeterminate,
      isAriaInvalid(selectProps['aria-invalid']) && controlStyles.error,
    ),
  placeholder: ({ selectProps }: { selectProps: SelectStateProps }) =>
    selectProps.indeterminate ? indeterminatePlaceholderStyles : placeholderStyles,
  input: () => selectInputStyles,
  valueContainer: () => valueContainerStyles,
  singleValue: () => singleValueStyles,
  multiValue: ({ selectProps }: { selectProps: SelectStateProps }) =>
    cn(multiValueStyles, selectProps.indeterminate && indeterminateMultiValueStyles),
  multiValueLabel: ({ selectProps }: { selectProps: SelectStateProps }) =>
    cn(multiValueLabelStyles, selectProps.indeterminate && indeterminateMultiValueLabelStyles),
  multiValueRemove: () => multiValueRemoveStyles,
  clearIndicator: ({ selectProps }: { selectProps: SelectStateProps }) =>
    cn(clearIndicatorStyles, selectProps.indeterminate && indeterminateClearIndicatorStyles),
  indicatorSeparator: ({ selectProps }: { selectProps: SelectStateProps }) =>
    cn(indicatorSeparatorStyles, selectProps.indeterminate && indeterminateIndicatorSeparatorStyles),
  dropdownIndicator: ({ selectProps }: { selectProps: SelectStateProps }) =>
    cn(dropdownIndicatorStyles, selectProps.indeterminate && indeterminateDropdownIndicatorStyles),
  menu: () => menuStyles,
  menuList: ({ selectProps }: { selectProps: SelectStateProps }) => cn(menuList, selectProps.menuListStyle),
  groupHeading: () => groupHeadingStyles,
  option: ({ isFocused, isSelected, isDisabled }: { isFocused: boolean; isSelected: boolean; isDisabled: boolean }) =>
    cn(
      isFocused && optionStyles.focus,
      isSelected && optionStyles.selected,
      isDisabled && optionStyles.disabled,
      optionStyles.base,
    ),
  noOptionsMessage: () => noOptionsMessageStyles,
};
